import * as React from 'react';
import { Card, Row, Col } from 'antd';
import { SettingOutlined, EllipsisOutlined } from '@ant-design/icons';

import { imageUrl, noImageUrl } from '../../../config/config';
import { getImageForVariant } from '../../../helpers/Images/getImageForVariant';
import Priority from './Priority';
import ProductTags from './ProductTags';

import { getVariantPriceWithout } from '../../../helpers/Prices/getVariantPriceWithout';
import { getPrivilegesTo } from 'src/helpers/Users/getPrivilegesTo';
import { privileges } from 'data-layer/src/services/Users/privileges';

export interface IVariantCardProps {
  enableDragAndDrop: boolean,
  category?: GQL.ICategory;
  product: GQL.IProduct;
  variant: GQL.IProductVariant;
  tags: GQL.IProductTag[];
  currency?: GQL.ICurrency;
  priority?: number;
  setCurrentProduct: (product: GQL.IProduct) => void;
  deleteProduct: (product: GQL.IProduct) => void;
  onChangePriority: (productId: string, priority: number) => void;
  onDragChange: (enableDragAndDrop) => void;
  // updateProductPriority: (variables) => void;
}

export class VariantCard extends React.PureComponent<IVariantCardProps> {

  constructor(props) {
    super(props);

    this.processDrop = this.processDrop.bind(this);
  }

  state = {
    sortingProduct: null,
  }

  public render() {
    const { category, product, variant, tags, priority, currency } = this.props;

    // výchozí obrázek
    const image = this.getImage();

    // cena varianty
    const price = currency ? getVariantPriceWithout(variant, currency) : null;

    const privilegesEditProducts = getPrivilegesTo(privileges.EDITING_PRODUCTS);

    return (
      <Row style={{ display: 'flex', alignItems: 'stretch' }}>
        {this.props.enableDragAndDrop &&
          <Col md={4}>
            <Card
              style={this.props.enableDragAndDrop
                ? { backgroundColor: '#F0FDF0', height: 'calc(100% - 16px)' }
                : { display: 'none' }}
              onDragOver={(ev) => ev.preventDefault()}
              onDrop={(ev) => this.processDrop(ev)}
              className={'droppable'}
            />
          </Col>}
        {this.props.enableDragAndDrop &&
          <Col md={2} />}
        <Col md={this.props.enableDragAndDrop ? 18 : 24}>
          <Card
            title={product.name['en'] || product.title}
            draggable={this.props.enableDragAndDrop}
            style={{
              marginBottom: 16
            }}
            hoverable={true}
            onDragStart={(ev) => {
              ev.dataTransfer.setData('text/plain', product.id);
            }}
            cover={
              <div className="catalog-product-box">
                <ProductTags
                  tags={tags}
                  variant={variant}
                />
                <div
                  style={{
                    width: '100%',
                    overflow: 'hidden',
                    textAlign: 'center',
                    height: 200,
                    lineHeight: '200px',
                    verticalAlign: 'middle'
                  }}
                >
                  <img
                    style={{ width: '100%' }}
                    onClick={() => this.props.setCurrentProduct(product)}
                    alt={product.name['en'] || product.title}
                    src={(image && `${imageUrl}/static/${image.file}`) || noImageUrl}
                  />
                </div>
              </div>
            }
            actions={[
              (privilegesEditProducts && category
                ? <div key={'drag'}><EllipsisOutlined key={'elipsis'} /></div>
                : null),
              (privilegesEditProducts 
                ? <span style={{ width: 20, height: 20 }} key={'setting'} onClick={() => this.props.setCurrentProduct(product)} >
                  <SettingOutlined />
                </span>
                : null),
              (privilegesEditProducts && category
                ? <Priority key={'priority'} variant={variant} value={priority} onChange={this.props.onChangePriority} />
                : null),
            ]}
          >
            <Card.Meta title={`SKU: ${product.sku}`} description={`Price: ${price && currency ? `${price} ${currency.value}` : `not defined`}`} />
          </Card>
        </Col>
      </Row>
    );
  }

  async processDrop(ev) {
    if (this.props.priority && this.props.category) {
      this.props.onChangePriority(ev.dataTransfer.getData('text/plain'), this.props.priority);
    }
  }

  private getImage() {
    const { product, variant } = this.props;
    return getImageForVariant(product, variant);
  }
}

export default VariantCard;



// WEBPACK FOOTER //
// ./src/scenes/Catalog/components/VariantCard.tsx